import styled from "styled-components";

import { colorsPalettes } from "@similarweb/styles";
import { Box, Flex, Stack } from "@similarweb/ui-components/foundations";

export const StyledContactWidget = styled.div`
    width: 253px;
    min-height: 144px;
    height: fit-content;
    background: ${colorsPalettes.carbon[0]};
    border: 1px solid ${colorsPalettes.carbon[50]};
    border-radius: 16px;
    margin: 0 16px 16px 0;
    padding: 16px 16px 4px 16px;
    box-sizing: border-box;
`;

export const TruncatableTitleWrapper = styled(Box)`
    min-width: 0;
    flex: 1;
`;

export const ShrinkableStack = styled(Stack)`
    min-width: 0;
`;

export const ShrinkableFlex = styled(Flex)`
    min-width: 0;
`;

export const StyledContactWidgetSkeleton = styled(StyledContactWidget)<{ top?: string; left?: string }>`
    position: absolute;
    height: 144px;
    padding: 16px;
    top: ${({ top }) => top || "0"};
    left: ${({ left }) => left || "0"};
`;
